import { useNavigate } from "react-router-dom";
import {
  Play,
  Shield,
} from "@phosphor-icons/react";
import { Button } from "../ui/button";

export function HeroSection({ isDark, stats }) {
  const navigate = useNavigate();

  return (
    <section className="relative pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 overflow-hidden">
        <div className={`absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-[128px] ${isDark ? 'bg-purple-600/20' : 'bg-purple-400/20'}`} />
        <div className={`absolute bottom-1/4 right-1/4 w-96 h-96 rounded-full blur-[128px] ${isDark ? 'bg-purple-800/20' : 'bg-purple-300/20'}`} />
      </div>
      
      <div className="relative max-w-7xl mx-auto text-center">
        <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border mb-8 ${isDark ? 'bg-purple-500/10 border-purple-500/20' : 'bg-purple-50 border-purple-200'}`}>
          <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
          <span className={`text-sm ${isDark ? 'text-purple-300' : 'text-purple-700'}`}>Live Opportunities Available</span>
        </div>
        
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold tracking-tight mb-6">
          <span className={isDark ? 'text-white' : 'text-gray-900'}>AI-Driven</span>
          <br />
          <span className="bg-gradient-to-r from-purple-400 via-purple-500 to-purple-600 bg-clip-text text-transparent">
            Investment Ideas
          </span>
          <br />
          <span className={isDark ? 'text-white' : 'text-gray-900'}>Daily.</span>
        </h1>
        
        <p className={`text-lg sm:text-xl max-w-2xl mx-auto mb-10 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
          MyQairo analyzes global markets and generates one high-probability 
          arbitrage opportunity every day. Real data. Real fundamentals. Real execution.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
          <Button
            onClick={() => navigate("/dashboard")}
            className="bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600 text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg shadow-purple-500/25 transition-all"
            data-testid="hero-cta-btn"
          >
            <Play size={20} weight="fill" className="mr-2" />
            View Today's Opportunity
          </Button>
          
          <div className={`flex items-center gap-2 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
            <Shield size={18} />
            <span className="text-sm">No credit card required</span>
          </div>
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="text-3xl sm:text-4xl font-bold text-purple-500">{stat.value}</p>
              <p className={`text-sm ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
